import script from "./BalPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalPopover.vue?vue&type=script&setup=true&lang=ts"

import "./BalPopover.vue?vue&type=style&index=0&id=05c0f5b0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c0f5b0"]])

export default __exports__